"use client"

import { CircleArrowOutDownLeft } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CircleArrowOutDownLeftIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CircleArrowOutDownLeftIcon = component(Icon)({
  as: CircleArrowOutDownLeft,
})
